import React, { useState } from "react";
import axios from "axios";
import WeatherForecast from "./WeatherForecast";
import WeatherInfo from "./WeatherInfo";

import "./Weather.css";

export default function Weather(props) {
  const [ready, setReady] = useState(false);
  const [weatherData, setWeatherData] = useState({});
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setReady(true);
    console.log(response.data);
    // Create a date object and adjust for the city's timezone
    let utcDate = new Date(response.data.dt * 1000);
    // Get the browser's timezone offset in seconds
    let browserOffsetSeconds = -utcDate.getTimezoneOffset() * 60;
    // Adjust for city timezone minus browser timezone to display correct local time
    let adjustment = (response.data.timezone - browserOffsetSeconds) * 1000;
    let cityDate = new Date(utcDate.getTime() + adjustment);
    setWeatherData({
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      wind: response.data.wind.speed,
      date: cityDate,
      description: response.data.weather[0].description,
      city: response.data.name,
      iconUrl: `https://openweathermap.org/payload/api/media/file/${response.data.weather[0].icon}.png`,
    });
  }

  function search() {
    const apiKey = "7797aa5c054d2bf0b327b9a77385efb6";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleSearch(event) {
    setCity(event.target.value);
  }
  if (ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="search"
                placeholder="Enter a city...."
                className="form-control"
                autoFocus="on"
                onChange={handleSearch}
                name="weather-search-form"
              />
            </div>
            <div className="col-3">
              <input
                type="submit"
                value="Search"
                className="btn btn-primary w-100"
              />
            </div>
          </div>
        </form>
        <WeatherInfo data={weatherData} />
        <WeatherForecast coordinates={weatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return "Loading....";
  }
}
